import { Component, AfterViewInit, ElementRef, PLATFORM_ID, Inject } from '@angular/core';
import { HeaderComponent } from '../../../Common/header/header.component';
import { FooterComponent } from '../../../Common/footer/footer.component';
import { RouterLink } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-top-rated-mutual-funds',
    templateUrl: './top-rated-mutual-funds.component.html',
    styleUrls: ['./top-rated-mutual-funds.component.scss'],
    standalone: true,
    imports: [RouterLink]
})
export class TopRatedMutualFundsComponent implements AfterViewInit {
  constructor(
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initializeObserver();
    }
  }

  initializeObserver(): void {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observerCallback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('img-slide-left', 'text-slide-right');
        }
      });
    };

    const imgElements = this.elementRef.nativeElement.querySelectorAll('.card-img-container img');
    const textElements = this.elementRef.nativeElement.querySelectorAll('.fancy-paragraph');

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    imgElements.forEach((imgElement: Element) => observer.observe(imgElement));
    textElements.forEach((textElement: Element) => observer.observe(textElement));
  }
}
